// extracted by mini-css-extract-plugin
export var downArrow = "_fh-0";
export var infoTooltipIcon = "_fh-3";
export var label = "_fh-1";
export var optionCard = "_fh-4";
export var upArrow = "_fh-2";